import API from "@/api/api-admin";
import datasMonitoringAPI from "@/api/api-datamonitoring";
import testsMonitoringAPI from "@/api/api-testmonitoring";
import i18n from "@/i18n";

const apiMapping = {
  monitoringDatas: datasMonitoringAPI,
  monitoringTests: testsMonitoringAPI,
};

const state = {
  resalesPhotos: null,
  resalesPhotosFilters: null,
  resalesNotPublished: null,
  resalesNotPublishedFilters: null,
  resales: null,
  resalesFilters: null,
  resalesNotReview: null,
  resalesNotReviewFilters: null,
  resalesNotShooting: null,
  resalesNotShootingFilters: null,
  vouchers: null,
  vouchersFilters: null,
  wallets: null,
  walletsFilters: null,
  customers: null,
  customersFilters: null,
  tableRequests: {},
  returns: null,
  returnsFilters: null,
  returnsTreated: null,
  returnsTreatedFilters: null,
  ordersReturns: null,
  ordersReturnsFilters: null,
  ordersReturnsOrder: null,
  ordersReturnsOrderFilters: null,
  bills: null,
  billsFilters: null,
  orders: null,
  ordersFilters: null,
  stock: null,
  stockFilters: null,
  translations: null,
  translationsFilters: null,
  admins: null,
  adminsFilters: null,
  soldArticles: null,
  soldArticlesFilters: null,
  exportLoading: false,
  exportIndex: 0,
  warehouseStocks: null,
  warehouseStocksFilters: null,
  resalesStocks: null,
  resalesStocksFilters: null,
  warehouseStocksRefused: null,
  warehouseStocksRefusedFilters: null,
  promotionsCredits: null,
  promotionsCreditsFilters: null,
  ordersReturned: null,
  ordersReturnedFilters: null,
  promotionsDebits: null,
  promotionsDebitsFilters: null,
  resalesCredited: null,
  resalesCreditedFilters: null,
  monitoringDatas: null,
  monitoringDatasFilters: null,
  monitoringTests: null,
  monitoringTestsFilters: null,
  resalesShipping: null,
  resalesShippingFilters: null,
  ordersReturnsTreated: null,
  ordersReturnsTreatedFilters: null,
  resalesBookings: null,
  resalesBookingsFilters: null,
  invoicesFolders: null,
  invoicesFoldersFilters: null,
  clientAvailableProducts: null,
  clientAvailableProductsFilters: null,
  storeTransferArticles: null,
  storeTransferArticlesFilters: null,
  retailTransferArticles: null,
  retailTransferArticlesFilters: null,
  retailAvailableProducts: null,
  retailAvailableProductsFilters: null,
  articles: null,
  articlesFilters: null,
  ordersRefunded: null,
  ordersRefundedFilters: null,
  ordersRefundedCms: null,
  ordersRefundedCmsFilters: null,
  ordersRefundedShopify: null,
  ordersRefundedShopifyFilters: null,
  recomVouchers: null,
  recomVouchersFilters: null,
  recomSubscribers: null,
  recomSubscribersFilters: null,
  recomSoldArticles: null,
  recomSoldArticlesFilters: null,
  recomTradeinArticles: null,
  recomTradeinArticlesFilters: null,
  recomPromocodes: null,
  recomPromocodesFilters: null,
  warehouseArticles: null,
  warehouseArticlesFilters: null,
  shippings: null,
  shippingsFilters: null,
};

const mutations = {
  SET_TABLE(state, data) {
    state[`${data.name}`] = { ...data.value };
  },
  SET_TABLE_FILTERS(state, data) {
    let filters = data.value;
    if (filters) {
      // Fix pour faire en sortes que options soit toujours un tableau d'objet
      filters.forEach((filter) => {
        if (filter?.options?.length && typeof filter.options[0] !== "object") {
          filter.options = filter.options.map((x) => ({ id: x, label: x }));
        }
      });
    }
    state[`${data.name}Filters`] = filters;
  },
  RESET_TABLE(state, name) {
    state[name] = null;
  },
  SET_EXPORT_LOADING(state, value) {
    state.exportLoading = value;
  },
  SET_EXPORT_INDEX(state) {
    state.exportIndex += 1;
  },
};

const actions = {
  getTable({ commit }, data) {
    const url = `${data.url}?${data.filters}`;
    const currentApi = apiMapping[data.name] || API;
    return currentApi
      .get(url)
      .then((res) => {
        if (res && res.data) {
          if (!res.data.items)
            res.data = {
              items: res.data,
            };
          commit("SET_TABLE", {
            name: data.name,
            value: res.data,
          });
        }
      })
      .catch((err) => {
        commit("SET_TABLE", {
          name: data.name,
          value: [],
        });
        console.error("Impossible de récupérer la table", err);
      });
  },
  exportTable({ commit, state }, { name, url, filters = "", format = "csv" }) {
    console.log("📊 === DÉBUT EXPORT TABLE ===");
    console.log("📍 URL:", url);
    console.log("📌 Name:", name);
    console.log("🔍 Filters:", filters || "Aucun filtre");
    console.log("📄 Format:", format);

    commit("SET_EXPORT_INDEX");
    commit("SET_EXPORT_LOADING", true);

    // URLs qui doivent envoyer par email au lieu de télécharger
    const emailExportUrls = [
      "/api/v2/admin/new-articles",
      "/api/v2/admin/new-customers",
      "/api/v2/admin/giftcards",
      "/api/v2/admin/marketing-subscription",
      "/api/v2/admin/new-orders",
      "/api/v2/admin/new-order-items",
      "/api/v2/admin/promocodes",
      "/api/v2/admin/tradeins",
      "/api/v2/admin/tradeins-items",
      "/api/v2/admin/cms-refunds",
      "/api/v2/admin/refunds",
      "new-articles",
      "new-customers",
      "giftcards",
      "marketing-subscription",
      "new-orders",
      "new-order-items",
      "promocodes",
      "tradeins",
      "tradeins-items",
      "cms-refunds",
      "refunds",
    ];

    // Vérifier si l'URL nécessite un envoi par email
    const shouldSendByEmail = emailExportUrls.some(emailUrl => 
      url.includes(emailUrl) || emailUrl === url
    );

    // Log du mode d'export
    if (shouldSendByEmail) {
      console.log("🚀 Mode ENVOI PAR EMAIL activé pour l'URL:", url);
    } else {
      console.log("💾 Mode TÉLÉCHARGEMENT DIRECT activé pour l'URL:", url);
    }

    // Préparation de la locale (identique)
    const rawLocale = i18n.global ? i18n.global.locale : i18n.locale;
    let locale;
    if (rawLocale.includes("_")) {
      locale = rawLocale;
    } else if (rawLocale === "fr") {
      locale = "fr_FR";
    } else if (rawLocale === "en") {
      locale = "en_GB";
    } else {
      locale = rawLocale;
    }

    // Préparation des paramètres avec gestion spéciale des virgules
    const params = new URLSearchParams();
    params.set("adminLocale", locale);

    // Construction manuelle de la query string pour préserver les virgules
    let queryParts = [`adminLocale=${locale}`];

    // Ajouter le format seulement si c'est xlsx (csv est le défaut côté API)
    if (format === "xlsx") {
      queryParts.push("format=xlsx");
    }
    
    if (filters) {
      filters.split("&").forEach((pair) => {
        const [k, v] = pair.split("=");
        if (k && v != null) {
          // Décoder d'abord la valeur pour voir si elle contient des virgules
          const decodedValue = decodeURIComponent(v);
          
          // Si le paramètre contient des crochets (array params) et des virgules dans la valeur décodée
          // on garde les virgules non-encodées
          if (k.includes("[") && decodedValue.includes(",")) {
            queryParts.push(`${k}=${decodedValue}`);
          } else {
            // Pour les autres paramètres, on garde la valeur originale (déjà encodée)
            queryParts.push(`${k}=${v}`);
          }
        }
      });
    }

    const queryString = queryParts.join("&");

    const currentApi = apiMapping[name] || API;
    console.log(
      "🔌 API utilisée:",
      apiMapping[name] ? `API spécifique pour ${name}` : "API par défaut"
    );

    return new Promise((resolve, reject) => {
      // Configuration de la requête selon le type d'export
      const requestConfig = shouldSendByEmail ? {} : { responseType: "blob" };

      console.log("⚙️ Configuration de la requête:", requestConfig);
      console.log("🌐 URL complète:", `${url}/export?${queryString}`);
      console.log("🔍 URL brute avant appel:", url);
      console.log("🔍 Contient /export ?", url.includes("/export"));

      currentApi
        .get(`${url}/export?${queryString}`, requestConfig)
        .then((res) => {
          if (shouldSendByEmail) {
            // Comportement pour envoi par email
            console.log("✅ Export par EMAIL réussi pour:", url);
            console.log("📧 Réponse du serveur:", res.data);
            resolve(res.data);
          } else {
            // Comportement pour téléchargement direct
            console.log("✅ Préparation du TÉLÉCHARGEMENT pour:", url);

            const blob = new Blob([res.data], {
              type: res.headers["content-type"] || "application/octet-stream",
            });

            // Récupérer le nom du fichier depuis le header si disponible
            let filename = format === "xlsx" ? "export.xlsx" : "export.csv";
            const contentDisposition = res.headers["content-disposition"];
            if (contentDisposition) {
              const match = contentDisposition.match(
                /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
              );
              if (match && match[1]) {
                filename = match[1].replace(/['"]/g, "");
              }
            }
            console.log("📄 Nom du fichier:", filename);

            // Créer un lien de téléchargement
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Libérer la mémoire
            setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 100);

            console.log("✅ Téléchargement déclenché avec succès!");
            resolve(blob);
          }
        })
        .catch((err) => {
          const errorMessage = shouldSendByEmail
            ? "❌ ERREUR lors de l'envoi de l'export par EMAIL :"
            : "❌ ERREUR lors du TÉLÉCHARGEMENT de l'export :";
          console.error(errorMessage, url);
          console.error("Détails de l'erreur:", err);
          reject(err);
        })
        .finally(() => commit("SET_EXPORT_LOADING", false));

      // Timeout de sécurité (identique)
      const index = state.exportIndex;
      setTimeout(() => {
        if (index === state.exportIndex) {
          commit("SET_EXPORT_LOADING", false);
        }
      }, 20_000);
    });
  },
  getTableFilters({ commit }, data) {
    const currentApi = apiMapping[data.name] || API;
    currentApi
      .get(`${data.url}/filters`)
      .then((res) => {
        if (res && res.data) {
          commit("SET_TABLE_FILTERS", {
            name: data.name,
            value: res.data,
          });
        }
      })
      .catch(() =>
        console.error(
          "Filtres non disponibles. Demandez à un développeur back d'activer cette route : ",
          `${data.url}/filters`
        )
      );
  },
  resetTable({ commit }, name) {
    commit("RESET_TABLE", name);
  },
};

const getters = {
  recomSoldArticlesWithTVA: (state) => {
    if (state.recomSoldArticles && state.recomSoldArticles.items) {
      return state.recomSoldArticles.items.map((article) => {
        article.priceTTC = article.price * (1 + article.tva / 100);
        return article;
      });
    }
    return null;
  },
};

const tables = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};

export default tables;